var map = {
	"./quest_icon_apple.png": 7653,
	"./quest_icon_breakfast.png": 8651,
	"./quest_icon_broccoli.png": 5383,
	"./quest_icon_cheese.png": 6956,
	"./quest_icon_choco.png": 9846,
	"./quest_icon_concentration.png": 1194,
	"./quest_icon_darts.png": 1925,
	"./quest_icon_dinner.png": 7700,
	"./quest_icon_dontevent.png": 3254,
	"./quest_icon_female.png": 6030,
	"./quest_icon_fish.png": 1570,
	"./quest_icon_glass.png": 4536,
	"./quest_icon_heart_dmb.png": 7909,
	"./quest_icon_highactive.png": 3064,
	"./quest_icon_immunity.png": 7107,
	"./quest_icon_lightning.png": 2709,
	"./quest_icon_lowactive.png": 9525,
	"./quest_icon_lunch.png": 8211,
	"./quest_icon_male.png": 9298,
	"./quest_icon_minrest.png": 1981,
	"./quest_icon_moon.png": 8533,
	"./quest_icon_moon_filled.png": 321,
	"./quest_icon_noactive.png": 2585,
	"./quest_icon_nodiet.png": 7092,
	"./quest_icon_num1.png": 1357,
	"./quest_icon_num2.png": 4635,
	"./quest_icon_num3.png": 1802,
	"./quest_icon_num4.png": 7705,
	"./quest_icon_other.png": 5112,
	"./quest_icon_purify.png": 4188,
	"./quest_icon_reducestress.png": 5033,
	"./quest_icon_regularactive.png": 2973,
	"./quest_icon_salt.png": 2296,
	"./quest_icon_skinlook.png": 283,
	"./quest_icon_sleepbetter.png": 1532,
	"./quest_icon_sleephero.png": 6010,
	"./quest_icon_sleeplong.png": 1060,
	"./quest_icon_somerest.png": 6736,
	"./quest_icon_sports.png": 7496,
	"./quest_icon_summer.png": 2989,
	"./quest_icon_sun.png": 5302,
	"./quest_icon_vacation.png": 7127,
	"./quest_icon_vit_abde.png": 2809,
	"./quest_icon_vit_antibio.png": 6821,
	"./quest_icon_vit_chemistry.png": 170,
	"./quest_icon_vit_dont.png": 8294,
	"./quest_icon_vit_other.png": 6452,
	"./quest_icon_wedding.png": 6841
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1227;